import PropTypes from "prop-types";
import React from "react";
import ProductgridList from "./ProductgridList";

const ShopProducts = (props) => {
  const { products, layout, isLoggedUser, visualizzaPrezzi, oneProduct } =
    props;
  return (
    <div
      className="shop-bottom-area mt-12"
      id="products-area"
      style={
        oneProduct
          ? {}
          : {
              overflowY: "scroll",
              maxHeight: "800px",
              maxWidth: "85vw",
              overflowX: "hidden",
              scrollbarWidth: "none",
            }
      }
    >
      <div className={`row ${layout ? layout : ""}`}>
        <ProductgridList
          isLoggedUser={isLoggedUser}
          visualizzaPrezzi={visualizzaPrezzi}
          products={products}
          spaceBottomClass="mb-25"
          oneProduct={oneProduct}
        />
      </div>
    </div>
  );
};

ShopProducts.propTypes = {
  layout: PropTypes.string,
  products: PropTypes.array,
};

export default ShopProducts;
